import { createAssetManagementClient } from '@/shared/api/client'
import { validateCompositeResponse } from '@/shared/api/validation'

const client = createAssetManagementClient()

export const cancelInvoice = (invoiceId: number) => validateCompositeResponse(
  client.sendPut(`billing/invoices/${invoiceId}/cancelled`)
)
